<template>
  <div>
    <div class="page-title">
      {{ $t('customerService.refund_search') }}
    </div>
    <div class="queryPay page-container">

      <div class="filter-right-container">
        <div class="filter-container-tag">
          {{ $t('components.activity') }}
        </div>
        <el-popover
          placement="bottom"
          trigger="click"
        >
          <div class="filter-section-container">
            <div id="filter-content" class="filter-content">
              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.original_transaction_id') }}</div>
                <el-input v-model="search.original_transaction_id" type="text" class="filter-item-value" clearable />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.mch_refund_order_id') }}</div>
                <el-input v-model="search.mch_order_id" type="text" class="filter-item-value" clearable />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.refund_transaction_id') }}</div>
                <el-input v-model="search.refund_transaction_id" type="text" class="filter-item-value" clearable />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.payer_mobile') }}</div>
                <el-input v-model="search.payer_mobile" type="text" class="filter-item-value" clearable />
              </div>
              <div class="filter-item" :class="{'border-red':isShowBorderRed || isShowBorderInvoiceRed}">
                <div class="filter-item-label">{{ $t('merchantAccount.complete_time') }}</div>
                <el-date-picker
                  v-model="search.response_times"
                  class="filter-item-value"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00','23:59:59']"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('components.start_date')"
                  :end-placeholder="$t('components.end_date')"
                />
              </div>
              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.refund_type') }}</div>
                <el-select v-model="search.refund_category" class="filter-item-value" clearable>
                  <el-option
                    v-for="(item,index) in refundStatusMap"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.refund_status') }}</div>
                <el-select v-model="search.status" class="filter-item-value" clearable>
                  <el-option
                    v-for="(item,index) in refundTypeMap"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
            </div>
            <div class="filter-operate">
              <div class="filter-operate-right">
                <el-button class="search-btn mb-10" @click="onClickReset">{{ $t('components.clear') }}</el-button>
                <el-button class="search-btn mb-10" type="primary" icon="el-icon-search" @click="onClickSearchBtn">{{ $t('components.search') }}</el-button>
              </div>

            </div>
          </div>
          <el-button slot="reference" class="mb-10 mr-12" type="info" plain>   <svg-icon class-name="mr-10" icon-class="filter" />{{ $t('components.filter') }}</el-button>
        </el-popover>
      </div>

      <div class="tableContainer">
        <el-table
          v-loading="listLoading"
          :data="tableData"
          stripe
          fit
          highlight-current-row
          style="width: 100%"
        >
          <!-- 原交易编号 -->
          <el-table-column min-width="110" :label="$t('customerService.original_transaction_id')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.original_transaction_id }}</span>
            </template>
          </el-table-column>
          <!-- 商户退款订单号 -->
          <el-table-column min-width="110" :label="$t('customerService.mch_refund_order_id')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.mch_order_id }}</span>
            </template>
          </el-table-column>
          <!-- 退款交易编号 -->
          <el-table-column min-width="110" :label="$t('customerService.refund_transaction_id')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.refund_transaction_id }}</span>
            </template>
          </el-table-column>
          <!-- 支付方式 -->
          <el-table-column min-width="110" :label="$t('customerService.payment_method')" align="center">
            <template slot-scope="scope">
              <span>{{ getPayinPaymentMethodMap(scope.row.pay_product_type) }}</span>
            </template>
          </el-table-column>
          <!-- 支付渠道 -->
          <el-table-column min-width="110" :label="$t('merchant.payment_channel')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.channel_code }}</span>
            </template>
          </el-table-column>
          <!-- 退款类型 -->
          <el-table-column :label="$t('customerService.refund_type')" align="center" min-width="150">
            <template slot-scope="scope">
              <div class="status-wrap">
                <el-tag :type="getRefundStatusMapType(scope.row.refund_category)" class="payin-status tag-custom"> {{ getRefundStatusMap(scope.row.refund_category) }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <!-- 原交易金额 -->
          <el-table-column min-width="110" :label="$t('customerService.original_transaction_amount')" align="center">
            <template slot-scope="scope">
              <span> {{ scope.row.original_transaction_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>
          <!-- 退款订单金额 -->
          <el-table-column min-width="110" :label="$t('customerService.refund_order_amount')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.this_time_refund_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>
          <!-- 退回手续费金额 -->
          <el-table-column min-width="110" :label="$t('customerService.refunded_transaction_fee')" align="center">
            <template slot-scope="scope">
              {{ Math.abs(scope.row.refund_transaction_fee) | toDivideWithDot }}
            </template>
          </el-table-column>
          <!-- 退款交易金额 -->
          <el-table-column min-width="110" :label="$t('customerService.refund_transaction_amount')" align="center">
            <template slot-scope="scope">
              <span>{{ Math.abs(scope.row.actual_receive_refund_amount) | toDivideWithDot }}</span>
            </template>
          </el-table-column>
          <!-- 退款手续费 -->
          <el-table-column min-width="110" :label="$t('customerService.refund_fee')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.refund_fee | toDivideWithDot }}</span>
            </template>
          </el-table-column>
          <!-- 退款状态 -->
          <el-table-column min-width="160" :label="$t('customerService.refund_status')" align="center">
            <template slot-scope="scope">
              <el-tag :type="getRefundTypeMapType(scope.row.status)" class="payin-status tag-custom"> {{ getRefundTypeMap(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column min-width="110" :label="$t('merchantAccount.create_time')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_create_time }}</span>
            </template>
          </el-table-column>

          <el-table-column min-width="110" :label="$t('merchantAccount.complete_time')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_return_time }}</span>
            </template>
          </el-table-column>
          <!--操作-->
          <el-table-column :label="$t('components.operation')" align="center" min-width="150">
            <template slot-scope="scope">
              <el-button type="info" size="small" plain @click="onClickDetailBtn(scope.row)">
                {{ $t('components.view_details') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="confirm" />
      </div>

      <refund-details-modal ref="RefundDetailsModal" :detail-id="detailId" />

    </div>

  </div>
</template>

<script>

import { refundCustomerSearch } from '@/api/customer-service/customer-service'
import { refundDetailTypeMap, refundStatusMap } from '@/utils/maps'
import { filterEmptyAttr } from '@/utils/common'
import { payinPaymentMethodMap } from '@/maps/transaction'
export default {
  name: 'Customer_Service_Query_Pay',
  components: {
    Paginator: () => import('@/views/components/Paginator.vue'),
    RefundDetailsModal: () => import('./components/Modal/RefundDetailsModal')
  },
  data() {
    this.timer = null
    return {
      isShowBorderRed: false,
      isShowBorderInvoiceRed: false,
      showFilterContent: true,
      search: {
        response_times: []
      },
      tableData: [],
      payTypeArr: [], // 支付类型数组
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      detailId: 0
    }
  },
  computed: {
    getPayinPaymentMethodMap() {
      return function(value) {
        return payinPaymentMethodMap(value).label
      }
    },
    refundStatusMap() {
      return refundStatusMap()
    },
    refundTypeMap() {
      return refundDetailTypeMap()
    },
    getRefundTypeMap() {
      return function(value) {
        return refundDetailTypeMap(value).label
      }
    },
    getRefundTypeMapType() {
      return function(value) {
        return refundDetailTypeMap(value).type
      }
    },
    getRefundStatusMapType() {
      return function(value) {
        return refundStatusMap(value).type
      }
    },
    getRefundStatusMap() {
      return function(value) {
        return refundStatusMap(value).label
      }
    }
  },
  created() {
  },
  methods: {
    onClickDetailBtn(row) {
      this.detailId = row.transaction_id
      this.showRefundDetailModal(row)
    },
    getParams(otherParams = {}) {
      const { response_times = [], ...otherSearch } = this.search

      let params = {
        transaction_return_time_start: response_times && response_times[0],
        transaction_return_time_end: response_times && response_times[1],
        ...otherSearch,
        ...otherParams
      }
      params = filterEmptyAttr(params)
      return params
    },
    handleFilter(params = {}) {
      const newParam = this.getParams(params)
      this.getPayOrderList(newParam)
    },
    confirm() {
      const params = {
        page: this.listQuery.page
      }
      this.handleFilter(params)
    },
    showRefundDetailModal(row) {
      this.$refs.RefundDetailsModal.changModalStatus(true, row)
    },
    onClickSearchBtn() {
      const { original_transaction_id, refund_transaction_id, payer_mobile, response_times, refund_category, status, mch_order_id } = this.search
      const [response_start_date] = response_times || []
      if (!response_start_date && !original_transaction_id && !refund_transaction_id && !refund_category && !payer_mobile && !status && !mch_order_id) {
        this.$message({ type: 'warning', showClose: true, duration: 5000, message: 'At least one parameter' })
        return
      }
      const { page, limit } = this.listQuery
      const params = {
        page,
        limit
      }
      this.handleFilter(params)
    },
    // 获取请求列表
    getPayOrderList(params = {}) {
      this.listLoading = true
      refundCustomerSearch(params).then(res => {
        if (res.code === 10000) {
          this.tableData = res.data.list
          this.listQuery.total = res.data.total
          this.listQuery.page = params.page ? params.page : 1
        }
      }).finally(() => {
        this.listLoading = false
        this.isShowBorderRed = false
      })
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    }
  }
}
</script>maps.js

<style lang="scss" scoped>
.icon-warning-outline{
  position: relative;
  top: 2px;
  color:  #4B5567;
  font-size: 16px;
}
.queryPay_popover_title{
  text-align: center;
  color: #606266;
}
.queryPay_textarea{
  margin-bottom: 20px;
}
.queryPay_btn-container{
  margin: 0 50px;
  display: flex;
  justify-content: space-between;
}
.queryPay_size-btn{
  width: 80px;
  height: 28px;
  line-height: 6px;
}
.queryPay{
  margin: 20px;
  background: #fff;
  border-radius: 4px;
  .pagination-container{
    padding: 20px;
    margin-top: 0;
  }
  .filter-container{
    padding: 40px 0 24px 24px;
  }

  .search-frame {
    width: 256px;
    margin-bottom: 10px;
    margin-right: 5px;
  }
  // .search-btn {
  //   margin-left: 10px;
  // }
  .tag-status{
    // text-decoration: underline;
    // cursor: pointer;
  }
}

</style>
